import {
  createScaffolderFieldExtension,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { UserInfo, UserPicker } from './UserPicker';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';

const UserPickerField = (props: FieldExtensionComponentProps<UserInfo>) => {
  const { onChange, uiSchema, formData, schema } = props;

  const label = uiSchema?.['ui:title'] || schema?.title || 'User';
  const placeholder = uiSchema?.['ui:placeholder'];
  useEffect(() => {
    if (formData && isEmpty(formData)) {
      onChange(undefined);
    }
    // eslint-disable-next-line
  }, []);
  const onUserSelect = (newUser: UserInfo | null) => {
    onChange(newUser ?? undefined);
  };

  return (
    <UserPicker
      onValueChange={onUserSelect}
      value={formData}
      label={label}
      placeholder={placeholder}
    />
  );
};

export const UserPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UserPicker',
    component: UserPickerField,
  }),
);
